<template>
	<div>
		<div class="tabshead body">
			<div class="tabshead1">
<!--				<div class="ksb yhq " :class="{active:qiehuan==1}" @click="qiehuan=1">-->
<!--					<span style="">商品信息</span>-->
<!--				</div>-->
			</div>
<!--			<div class="ksb yhq " @click="qiehuan=2" :class="{active:qiehuan==2}" style="margin-left: 15px">-->
<!--				<span style="">优惠券</span>-->
<!--			</div>-->
		</div>
		<div class="body martop15" v-show="qiehuan==1">
			<el-row>
				<el-col :span="1" style="width:121px;padding-top: 8px ">
					<tiao :neir="'商品添加'"></tiao>
				</el-col>
				<el-col :span="23" style="width:900px ">
					<div class="ksb_qh1_2">
						<span class="ksb_qh1_2_1">名称：</span>
						<input class="ksb_qh1_2_1_m" v-model="ksbname" type="text" name="s_name" required="">
						<span class="ksb_qh1_2_2">金额：</span>
						<span class="ksb_qh1_2_2_3">
							<input class="ksb_qh1_2_2_3_i1" v-model="ksbjine" type="number" min="0" name="price" required="">
						</span>
						<span class="ksb_qh1_2_1_2">
							次数：
						</span>
						<span class="ksb_qh1_2_2_3">
							<input class="ksb_qh1_2_2_3_i3" type="number" v-model="ksbjieshu" min="0" name="k_shu" required="">
						</span>

						<input type="button" value="确认添加" @click="tianksb" class="ksb_qh1_3" style="cursor: pointer">
					</div>
				</el-col>

				<el-col :span="24" style="margin-top: 15px; ">
					<tiao :neir="'商品列表'"></tiao>
				</el-col>
				<el-col :span="24" style="margin-top: 15px">
					<table class="table table-hover table-bordered">
						<thead>
							<tr>
								<th style="text-align: center">商品名称</th>
								<th style="text-align: center">金额/元</th>
								<th style="text-align: center">次数</th>
								<th style="text-align: center">操作</th>
							</tr>
						</thead>
						<tbody style="text-align: center" v-loading="loading2">
							<tr v-for="ta in tab1">
								<td>{{ta.s_name}}</td>
								<td>{{ta.price}}</td>
								<td>{{ta.k_shu}}</td>
								<td>
									<el-button @click="shanchu1(ta.s_id)" round size="small"> 删除商品</el-button>
								</td>
							</tr>

						</tbody>
					</table>

				</el-col>


			</el-row>


			<div class="table-bottom">
				<div>
					<el-pagination @current-change="fanye" :page-size="pageong" background :current-page="curpage" layout="prev, pager, next"
					 :total="zongt">
					</el-pagination>
				</div>

			</div>

		</div>
		<div class="body martop15" v-show="qiehuan==2">

			<el-row>
				<el-col :span="1" style="width:121px;padding-top: 8px ">
					<tiao :neir="'优惠券添加'"></tiao>
				</el-col>
				<el-col :span="23" style="width:865px ">
					<div class="ksb_qh1_2">
						<span class="ksb_qh1_2_1" style="width: 140px">
							优惠券名称：
						</span>
						<input class="ksb_qh1_2_1_m" type="text" v-model="ksbname2" name="s_name" required="">
						<span class="ksb_qh1_2_2">
							金额：
						</span>
						<span class="ksb_qh1_2_2_3">
							<input class="ksb_qh1_2_2_3_i1" type="number" min="0" v-model="ksbjine2" name="price" required="">
						</span>


						<input type="button" style="cursor: pointer" @click="tianyhq" value="确认添加" class="ksb_qh1_3">
					</div>
				</el-col>

				<el-col :span="24" style="margin-top: 15px; ">
					<tiao :neir="'优惠券列表'"></tiao>
				</el-col>
				<el-col :span="24" style="margin-top: 15px">
					<table class="table table-hover table-bordered">
						<thead>
							<tr>
								<th style="text-align: center">优惠券名称</th>
								<th style="text-align: center">金额/元</th>
								<th style="text-align: center">操作</th>
							</tr>
						</thead>
						<tbody style="text-align: center" v-loading="loading3">
							<tr v-for="(t,index) in tab2" :key="index">
								<td>{{t.s_name}}</td>
								<td>{{t.price}}</td>
								<td>
									<el-button round size="small" @click="shanchu2(t.s_id)"> 删除优惠券</el-button>
								</td>

							</tr>

						</tbody>
					</table>

				</el-col>


			</el-row>


			<div class="table-bottom">
				<div>
					<el-pagination @current-change="fanye2" :page-size="pageong2" background :current-page="curpage2" layout="prev, pager, next"
					 :total="zongt2">
					</el-pagination>
				</div>

			</div>
		</div>

	</div>

</template>

<script>
	import tiao from '@/components/tiao'
	export default {
		components: {
			tiao
		},
		data() {
			return {
				qiehuan: 1,
				pageong: 10,
				curpage: 1,
				zongt: 1000,
				loading2: false,
				loading3: false,
				tab1: '',
				token: '',
				ksbname: '',
				ksbjine: '',
				ksbjieshu: '',
				ketype:1,
				option2:'',
				pageong2: 10,
				curpage2: 1,
				zongt2: 1000,
				tab2: '',
				ksbname2: '',
				ksbjine2: '',


			};
		},
		methods: {
			jump: function(d) {
				this.$router.push(d)
			},
			tianksb: function() {
				let self = this;
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/kecb/add",
					dataType: 'json',
					data: {
						token: self.token,
						s_name: self.ksbname,
						price: self.ksbjine,
						k_shu: self.ksbjieshu,
						item_id:self.ketype,
					},
					success: function(data) {
						if (data.status == 1) {
							self.$message.success(data.msg);
							self.curpage = 1;

							$.ajax({
								type: 'post',
								url: process.env.apiUrl + "saas/kecb/index",
								dataType: 'json',
								data: {
									token: self.token,
									p: self.curpage
								},
								beforeSend: function(xhr) {
									self.loading2 = true
								},
								success: function(data) {
									self.ksbname = '';
									self.ksbjine = '';
									self.ksbjieshu = '';
									self.ketype = 1;
									self.tab1 = data.data;
									self.zongt = data.num;
									self.curpage = Number(data.page);
									self.loading2 = false;
								},
								error: function() {
									self.$message.error(`请求失败`);
									self.loading2 = false
								}
							});







						} else {
							self.$message.error(data.msg);
						}

					},
					error: function() {
						self.$message.error(`请求失败`);

					}
				});

			},
			tianyhq: function() {
				let self = this;
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/kecb/addy",
					dataType: 'json',
					data: {
						token: self.token,
						s_name: self.ksbname2,
						price: self.ksbjine2
					},

					success: function(data) {

						if (data.status == 1) {
							self.$message.success(data.msg);
							self.curpage2 = 1;
							$.ajax({
								type: 'post',
								url: process.env.apiUrl + "saas/kecb/index1",
								dataType: 'json',
								data: {
									token: self.token,
									p: self.curpage2
								},
								beforeSend: function(xhr) {
									self.loading3 = true
								},
								success: function(data) {
									self.ksbname2 = '';
									self.ksbjine2 = '';
									self.tab2 = data.data;
									self.zongt2 = data.num;
									self.curpage2 = data.page;
									self.loading3 = false;
								},
								error: function() {
									self.$message.error(`请求失败`);
									self.loading3 = false
								}
							});
						} else {
							self.$message.error(data.msg);
						}
					},
					error: function() {
						self.$message.error(`请求失败`);

					}
				});


			},
			fanye: function(i) {
				let self = this;
				self.curpage = i;
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/kecb/index",
					dataType: 'json',
					data: {
						token: self.token,
						p: self.curpage
					},
					beforeSend: function(xhr) {
						self.loading2 = true
					},
					success: function(data) {

						console.log(data)

						self.tab1 = data.data;
						self.zongt = data.num;
						self.curpage = data.page;
						self.loading2 = false;

					},
					error: function() {
						self.$message.error(`请求失败`);
						self.loading2 = false
					}
				});

			},
			fanye2: function(i) {
				let self = this;
				self.curpage2 = i;
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/kecb/index1",
					dataType: 'json',
					data: {
						token: self.token,
						p: self.curpage2
					},
					beforeSend: function(xhr) {
						self.loading3 = true
					},
					success: function(data) {
						self.tab2 = data.data;
						self.zongt2 = data.num;
						self.curpage2 = data.page;
						self.loading3 = false;
					},
					error: function() {
						self.$message.error(`请求失败`);
						self.loading3 = false
					}
				});
			},
			shanchu1: function(id) {
				let self = this;

				self.$confirm('确认删除这条信息吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					$.ajax({
						type: 'post',
						url: process.env.apiUrl + "saas/kecb/del",
						dataType: 'json',
						data: {
							token: self.token,
							id: id
						},
						success: function(data) {
							if (data.status == 1) {
								self.$message.success(`删除成功`);
								$.ajax({
									type: 'post',
									url: process.env.apiUrl + "saas/kecb/index",
									dataType: 'json',
									data: {
										token: self.token,
										p: self.curpage
									},
									beforeSend: function(xhr) {
										self.loading2 = true
									},
									success: function(data) {
										self.tab1 = data.data;
										self.zongt = data.num;
										self.curpage = Number(data.page);
										self.loading2 = false;
									},
									error: function() {
										self.$message.error(`请求失败`);
										self.loading2 = false
									}
								})

							} else {
								self.$message.success(data.msg);
							}
						},
						error: function() {
							self.$message.error(`请求失败`);
						}
					});




				}).catch(() => {

				})






			},

			shanchu2: function(id) {
				let self = this;



				self.$confirm('确认删除这条消息吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					$.ajax({
						type: 'post',
						url: process.env.apiUrl + "saas/kecb/dely",
						dataType: 'json',
						data: {
							token: self.token,
							id: id
						},

						success: function(data) {

							if (data.status == 1) {
								self.$message.success(`删除成功`);
								$.ajax({
									type: 'post',
									url: process.env.apiUrl + "saas/kecb/index1",
									dataType: 'json',
									data: {
										token: self.token,
										p: self.curpage2
									},
									beforeSend: function(xhr) {
										self.loading3 = true
									},
									success: function(data) {

										self.tab2 = data.data;
										self.zongt2 = data.num;
										self.curpage2 = Number(data.page);
										self.loading3 = false;

									},
									error: function() {
										self.$message.error(`请求失败`);
										self.loading3 = false
									}
								});


							} else {
								self.$message.success(data.msg);
							}

						},
						error: function() {
							self.$message.error(`请求失败`);
						}
					});



				}).catch(() => {

				})













			}


		},
		mounted: function() {
			let self = this;
			self.token = self.$cookies.get('token');
			$.ajax({
				type: 'post',
				url: process.env.apiUrl + "saas/kecb/index",
				dataType: 'json',
				data: {
					token: self.token
				},
				beforeSend: function(xhr) {
					self.loading2 = true
				},
				success: function(data) {

					console.log(data)

					self.tab1 = data.data;
					self.zongt = data.num;
					self.curpage = data.page;
					self.loading2 = false;
					//                self.tab1=data.data;


				},
				error: function() {
					self.$message.error(`请求失败`);
					self.loading2 = false
				}
			});

			$.ajax({
				type: 'post',
				url: process.env.apiUrl + "saas/kecb/index1",
				dataType: 'json',
				data: {
					token: self.token
				},
				beforeSend: function(xhr) {
					self.loading3 = true
				},
				success: function(data) {
					console.log(data)
					self.tab2 = data.data;
					self.zongt2 = data.num;
					self.curpage2 = Number(data.page);
					self.loading3 = false;
					//                self.tab1=data.data;
				},
				error: function() {
					self.$message.error(`请求失败`);
					self.loading3 = false
				}
			});
			// 合约类型
			$.ajax({
				type: 'post',
				url: process.env.apiUrl + "saas/Contract/item_see",
				dataType: 'json',
				data: {token:self.token},
				success: function(data) {
					console.log(data)
					self.option2 = data.data;
				},
				error: function() {
					self.$message.error(`请求失败`);
				}
			});




		}

	}
</script>

<style scoped>
	.body {
		padding-left: 45px;
		padding-right: 45px;
		font-size: 14px;
		color: #666;
	}

	ul {
		list-style: none;
	}

	.tabshead {
		border-bottom: 1px solid #f2f2f2;
		height: 50px;
		display: flex;
		display: -webkit-flex;
		align-items: flex-end;
	}

	.ksb {
		width: 94px;
		border-radius: 5px 5px 0 0;
		height: 38px;
		line-height: 38px;
		text-align: center;
		float: left;
		cursor: pointer;
	}

	.ksb.active {
		color: #E6BE8A;
		background: #ececff;
		border-radius: 5px;
	}

	.tabshead1 {
		display: flex;
		display: -webkit-flex;
		align-items: flex-end;
	}

	.yhq {
		border-radius: 5px 5px 0 0;
		width: 94px;
		height: 38px;
		line-height: 38px;
		text-align: center;
		float: right;
		cursor: pointer;
		color: white;
		background: #E6BE8A;
	}

	.martop15 {
		margin-top: 15px;
	}

	.ksb_qh1_2 {
		width: auto;
		padding-right: 10px;
		height: 48px;
		float: left;
		border: 1px solid #dbdbdb;
		box-shadow: 1px 1px 2px #dbdbdb;
	}

	.ksb_qh1_2_1 {
		display: block;
		float: left;
		width:60px;
		height: 48px;
		line-height: 48px;
		text-align: center;
	}

	.ksb_qh1_2_1_m {
		display: block;
		float: left;
		width: 130px;
		height: 30px;
		margin-top: 8px;
	}

	.ksb_qh1_2>span {
		display: block;
		float: left;
	}

	.ksb_qh1_2_2 {
		height: 48px;
		line-height: 48px;
		width: 48px;
		margin-left:25px;
	}

	.ksb_qh1_2>span {
		display: block;
		float: left;
	}

	.ksb_qh1_2_2_3 {
		/* width: 122px; */
		height: 48px;
		line-height: 48px;
	}

	.ksb_qh1_2>span {
		display: block;
		float: left;
	}

	.ksb_qh1_2_1_2 {
		width: 50px;
		height: 48px;
		line-height: 48px;
		margin-left:25px;
	}

	.ksb_qh1_2_2_3_i3 {
		width: 80px;
		height: 28px;
		margin-left: 4px;
		margin-top: 8px;
	}
	.ksb_qh1_2_1_4 {
		/* width: 50px; */
		height: 48px;
		line-height: 48px;
		margin-left: 25px;
	}
	.ksb_qh1_3 {
		width: 130px;
		height: 34px;
		border-radius: 17px;
		background: #E6BE8A;
		color: white;
		margin-left:30px;
		margin-top: 6px;
		text-align: center;
		line-height: 34px;
		border: none;
		outline:none;
		box-shadow: 1px 1px 4px #999;
		-webkit-box-shadow: 1px 1px 4px #999;
	}

	.ksb_qh1_2_2_3_i1 {
		width: 65px;
		height: 28px;
	}

	.table-bottom {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		display: -webkit-flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
	}
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/xitong/shangpins.vue